const fontNameNormalizer = fontName => fontName.replace(/"/g, '').toLowerCase();

export function filterFonts(baseList, narrowedList) {
	const mappedPossibleFonts = narrowedList.map(fontNameNormalizer);
	return baseList.filter(fontName => mappedPossibleFonts.includes(fontNameNormalizer(fontName)))
}
